module.exports = __webpack_public_path__ + "static/media/dashboard.028eea7b.png";